export const authorEn = {
  navbar_author: {
    author: 'Authors',
    authors: 'Authors',
    authorInfo: 'Info',
    contents: 'Contents',
    myPage: 'Author-Page',
    editProfile: 'Edit Profile',
    contentsDescription: 'List all your contents and manage your claims',
    authorsDescription: 'Search and view all authors',
    myPageDescription: 'View your author page',
    claimsDescription: 'Claim contents',
    accountInfoDescription: 'View your account information'
  },
  home_author: {
    myPage: 'Author Page',
    myPageDescription: 'View your public author page',
    contents: 'My Content',
    contentsDescription: 'List all your contents and manage your claims',
    authors: 'Authors',
    authorsDescription: 'Search and view all authors',
    claims: 'Claims',
    claimsDescription: 'Claim contents',
    myAccount: 'My Account',
    myAccountDescription: 'View your account information',
    settings: 'Settings',
    settingsDescription: 'Configure application settings and preferences'
  },
  authors: {
    authors: "Authors"
  },
  authorContentList: {
    title: 'Claims',
    description: 'This panel displays all content items claimed by the author. You can view the status of each claim and see which publisher has verified the content. If you are the author, you can claim additional content and directly manage your claimed items here.',
    public: {
      title: 'Claiming ...',
      description: 'This panel shows all content items currently claimed by the author and pending verification.'
    }
  },
  authorView: {
    publisher: 'Publisher',
    content: 'Content',
    viewArticle: 'View Article'
  },
  authorsList: {
    title: 'Authors',
    description: {
      title: 'About this page',
      content: 'Search for authors by name to find their profiles and content. Browse author information, view their claimed content, and discover new authors in the system.',
    },
    searchCriteria: {
      name: 'Matches any author name that contains the search term (partial match)',
      orcid: 'Search by ORCID identifier (format: XXXX-XXXX-XXXX-XXXX)',
      home_page: 'Search by home page URL',
      email: 'Search by email address (wildcard patterns not allowed)',
      custom: 'Search by a custom field name'
    },
    customFieldPlaceholder: 'Enter field name',
    customFieldDescription: 'Enter a custom field name to search by. Examples: orcid, scholar, linkedin, ...',
    searchButton: 'Search',
    noAuthorsFound: 'No authors found.'
  },
  registrationType: {
    author: {
      introduction: {
        features: {
          feature1: 'Claim contents you have authored',
          feature2: 'Track the status of your claims',
          feature3: 'Access your claim history',
          feature4: 'Access to the author dashboard',
        },
      },
    },
  },  
  claim: {
    publisher: 'Publisher',
    publisher_name: 'Publisher Name',
    claimResources: 'Claim Contents',
    itemsPerPage: 'Items per page',
    loading: 'Loading items...',
    error: 'Error loading items: {error}',
    noItems: 'No item, found.',
    statuses: {
      awaiting_publisher_role: 'Awaiting Publisher Role',
      accepted: 'Accepted',
      pending: 'Pending',
      auto_verified: 'Auto Verified',
      verified: 'Verified',
      rejected: 'Rejected',
      notified: 'Notified',
      content_trashed: 'Content Removed',
      no_response: 'No Response',
      added_by_publisher: 'Added by Publisher'
    },
    list: {
      name: 'Name',
      resource: 'Resource',
      contentId: 'Content ID',
      publisher: 'Publisher',
      status: 'Status',
      lastModified: 'Last Modified',
      actions: 'Actions',
      not_available: 'N/A'
    },
    filters: {
      allStatuses: 'All',
      resourcePlaceholder: 'Filter by URL...',
      clear: 'Clear Filters'
    },
    wizard: {
      resourceClaiming: {
        authorIsPublisher: {
          title: 'You are the publisher',
          description: 'You are the publisher of this content. You can claim it as a publisher.',
        },
        title: 'Claim Contents',
        description: 'Search for articles you\'ve authored or add them directly by URL. You can claim multiple contents.',
        searchPlaceholder: 'Search for articles by title or keywords',
        urlPlaceholder: 'https://example.com/your-article',
        resourceUrl: 'Content URL',
        rootUrlPlaceholder: 'https://your-domain.com or https://your-profile-page.com',
        search: 'Search',
        addUrl: 'Claim',
        claim: 'Claim',
        claiming: 'Claiming...',
        claimSuccess: 'Content claimed successfully!',
        claimError: 'Failed to claim content. Please try again.',
        checkClaim: 'Check Claim',
        cancelClaimAttempt: 'Cancel Claim Attempt',
        checking: 'Checking...',
        checkSuccessWithContact: 'URL can be claimed! Publisher contact information found and pre-filled.',
        checkSuccessNoContact: 'This content is not yet known by Recognyze.AI. Please indicate if you are the publisher or provide the publisher contact information.',
        checkAlreadyClaimed: 'This URL has already been claimed by another author.',
        alreadyClaimedByYou: 'You have already claimed this URL.',
        alreadyClaimedByAnother: 'This URL has already been claimed by another author, but you can claim it as an author.',
        publisherFoundAutoAssigned: 'A publisher has been found for this domain. You can claim this content and the publisher will be notified.',
        alreadySignedByPublisher: 'This content has been signed by a publisher. You can claim it as an author.',
        checkError: 'Failed to check claim. Please try again.',
        cannotClaim: 'Cannot claim this URL. Please check the URL first.',
        mustCheckFirst: 'Please check the claim first before proceeding.',
        addRootUrl: 'Discover Contents',
        imThePublisher: 'I\'m the publisher',
        discoverFromRoot: 'Add Root URL and discover all contents',
        discovering: 'Discovering contents...',
        searchResults: 'Search Results',
        discoveredResources: 'Discovered Contents',
        claimed: 'Claimed',
        remove: 'Remove',
        claimedArticles: 'Claimed Contents',
        warning: 'Please ensure you only claim contents you have actually authored.',
        claimMore: 'Claim More Contents',
        continueProcess: 'Continue to Publisher Discovery',
        discoveryResults: {
          found: 'Found {count} content(s) from {domain}',
          method: 'Discovery method: {method}',
          estimatedTotal: 'Estimated total contents: {total}',
          claimSelected: 'Claim Selected',
          claimAll: 'Claim All',
          selectAll: 'Select All',
          deselectAll: 'Deselect All'
        },
        resourceTypes: {
          academic_paper: 'Academic Paper',
          technical_report: 'Technical Report',
          presentation: 'Presentation',
          blog_post: 'Blog Post',
          documentation: 'Documentation',
          other: 'Other'
        },
        contactInfo: {
          title: 'Publisher Contact Information',
          description: 'If you are not the publisher of this content, please provide contact information for the publisher. This helps us verify your authorship claim.',
          name: 'Name',
          email: 'Email',
          phone: 'Phone',
          domain: 'Domain',
          optional: '(Optional)',
          namePlaceholder: 'Publisher Name or Organization',
          emailPlaceholder: 'publisher@example.com',
          phonePlaceholder: '+1 (555) 123-4567',
          domainPlaceholder: 'https://publisher-domain.com',
          nameRequired: 'Publisher name is required when you are not the publisher.'
        },
        existingClaim: {
          title: 'Existing Claim Found',
          claimId: 'Claim ID',
          authorId: 'Author ID',
          claim: 'Claim',
          author: 'Author',
          status: 'Status',
          viewClaim: 'View Claim'
        },
        publisherContact: {
          title: 'Publisher Contact Found',
          name: 'Name',
          website: 'Website'
        },
        publisherContactFound: 'Publisher contact information has been found.',
        lastClaimed: {
          title: 'Your recent claims history',
          url: 'URL',
          status: 'Status',
          claimId: 'Claim ID',
          timestamp: 'Claimed At',
          youArePublisher: 'You are marked as the publisher of this resource'
        },
        status: {
          pending: 'Pending',
          verified: 'Verified',
          rejected: 'Rejected',
          notified: 'Notified',
          autoVerified: 'Auto Verified',
          awaitingPublisherRole: 'Awaiting Publisher Role',
          noResponse: 'No Response',
          unknown: 'Unknown'
        },
        signedContents: {
          title: 'Signed Contents'
        },
        publisherRegistrationNotice: 'You need to register as a publisher to claim content as a publisher.',
        registerAsPublisher: 'Go to Publisher Registration',
        publisherRoleCheckNotice: 'After completing registration on the Publisher website, click below to verify your publisher role.',
        checkPublisherRole: 'Verify Publisher Role',
        checkingRole: 'Checking...',
        publisherRoleConfirmed: 'Publisher role confirmed! You can now proceed with claiming content.',
        publisherRoleNotConfirmed: 'Publisher role not yet confirmed. Please complete registration and try again.',
        publisherRoleCheckError: 'Failed to check publisher role. Please try again.',
        cancelRegistration: 'Cancel Registration'
      }
    }
  },
  wizard: {
    title: 'Author Account Registration',
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
    finish: 'Finish'
  },
  postLogin: {
    title: 'Claim Contents',
    description: 'Search for articles you\'ve authored or add them directly by URL. You can claim multiple contents.',
    steps: {
      search: 'Search',
      repeat: 'Repeat',
      discovery: 'Discovery',
      notification: 'Notification',
      tracking: 'Tracking',
      unknown: 'Unknown'
    },
    navigation: {
      dashboard: 'Dashboard',
      profile: 'Profile',
      analytics: 'Analytics'
    }
  },
  profileSetup: {
    orcid: 'ORCID',
    orcidPlaceholder: '0000-0000-0000-0000',
    orcidHelp: 'Your ORCID identifier (optional)',
    linkedin: 'LinkedIn Profile',
    linkedinPlaceholder: 'https://linkedin.com/in/your-profile',
    linkedinHelp: 'Your LinkedIn profile URL (optional)',
    googleScholar: 'Google Scholar',
    googleScholarPlaceholder: 'Your Google Scholar profile ID',
    googleScholarHelp: 'Your Google Scholar profile URL (optional)',
    avatarUrl: 'Avatar URL',
    avatarUrlPlaceholder: 'https://example.com/avatar.jpg',
    avatarUrlHelp: 'Your avatar URL (optional)',
    changeAvatar: 'Change Avatar',
    noAvatar: 'No avatar',
    errors: {
      invalidLinkedin: 'Please enter a valid LinkedIn URL.',
      invalidOrcidId: 'Please enter a valid ORCID ID format (XXXX-XXXX-XXXX-XXXX).'
    }
  },
  profile: {
    key_ORCID: "ORCID",
    key_LINKEDIN: "LinkedIn",
    key_GOOGLE_SCHOLAR: "Google Scholar"
  },
  settings: {
    title: 'Settings',
    rIndexCache: {
      title: 'AI-Index Cache Settings',
      description: 'Configure how long AI-Index data is cached in your browser to reduce API calls and improve performance.',
      expirationLabel: 'Cache Expiration Time',
      expirationHint: 'Data cached for longer periods reduces API calls but may show outdated information. Changes only affect new cache entries.',
      expirationOptions: {
        '1hour': '1 Hour',
        '6hours': '6 Hours',
        '24hours': '24 Hours',
        '7days': '7 Days'
      },
      clearCacheButton: 'Clear AI-Index Cache',
      clearCacheHint: 'Remove all cached AI-Index data. This will force fresh data to be fetched from the server on next visit.',
      statsLabel: 'Cache Statistics',
      statsValue: '{entries} entries, {size} KB',
      clearCacheDialogTitle: 'Clear AI-Index Cache',
      clearCacheDialogMessage: 'Are you sure you want to clear all cached AI-Index data? This will remove all cached entries and force fresh data to be fetched on the next visit.',
      clearCacheConfirm: 'Clear Cache',
      clearCacheCancel: 'Cancel',
      clearCacheSuccess: 'AI-Index cache cleared successfully!'
    },
    trafficCache: {
      title: 'Traffic Analytics Cache Settings',
      description: 'Configure how Traffic Analytics data is cached in your browser to improve loading performance.',
      expirationLabel: 'Cache Expiration Time',
      expirationHint: 'How long to keep cached traffic data before refreshing from the server. Changes only affect new cache entries.',
      expirationOptions: {
        '1hour': '1 Hour',
        '6hours': '6 Hours',
        '24hours': '24 Hours',
        '7days': '7 Days'
      },
      clearCacheButton: 'Clear Traffic Cache',
      clearCacheHint: 'Remove all cached Traffic Analytics data. This will force fresh data to be fetched from the server on next visit.',
      statsLabel: 'Cache Statistics',
      statsValue: '{entries} entries, {size} KB',
      clearCacheDialogTitle: 'Clear Traffic Analytics Cache',
      clearCacheDialogMessage: 'Are you sure you want to clear all cached Traffic Analytics data? This will remove all cached entries and force fresh data to be fetched on the next visit.',
      clearCacheConfirm: 'Clear Cache',
      clearCacheCancel: 'Cancel',
      clearCacheSuccess: 'Traffic Analytics cache cleared successfully!'
    }
  }
};